<template>
    <div>
        <mobile-template>
            <div class="p-6 bg-white">
                <h1 class="text-2xl font-bold mb-4 pb-4 border-b">Nouvelle intervention</h1>
                <div v-if="displayForm">
                    <intervention-form v-model="formIntervention" />
                    <div v-if="formIntervention.client_id && formIntervention.client_appareil_id && formIntervention.type_id && formIntervention.duree_estimee" class="flex flex-col items-center space-y-4 justify-center mt-6">
                        <template v-if="loadingAddIntervention">
                            <i class="fas fa-spinner fa-spin"></i>
                        </template>
                        <template v-if="!loadingAddIntervention">
                            <!-- <div>
                                <button :disabled="loadingAddIntervention" @click="addIntervention(1)" class="bg-red-600 text-white px-8 py-4 rounded-lg shadow hover:bg-red-700 duration-200 text-lg font-bold">
                                    Enregistrer et planifier l'intervention
                                </button>
                            </div> -->
                            <div>
                                <button :disabled="loadingAddIntervention" @click="addIntervention(0)" class="bg-slate-300 text-slate-800 px-8 py-4 rounded-lg shadow hover:bg-slate-800 hover:text-white duration-200">
                                    Enregistrer et planifier plus tard
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </mobile-template>
    </div>
</template>

<script>
import InterventionForm from "./../Intervention/Components/InterventionForm.vue";

export default {
    name: "NewInterventionWidget",
    components: {
        InterventionForm,
    },
    data() {
        return {
            formIntervention: {},
            loadingAddIntervention: false,

            displayForm: true,
        }
    },
    methods: {
        async addIntervention(planifier) {
            this.loadingAddIntervention = true
            let response = await this.$request.post('/interventions', this.formIntervention);
            if (response && response.intervention) {
                this.$toast.success("Intervention enregistrée");
                this.$eventHub.$emit('refresh-intervention-table');
                this.$modal.hide(this.id ? this.id : 'modal-add-intervention');
                this.formIntervention = {}
            } else {
                this.$toast.error("Une erreur est survenue lors de l'enregistrement de l'intervention");
            }
            this.loadingAddIntervention = false

            if (planifier) {
                this.$modal.show('modal-planify-intervention', { intervention_id: response.id });
                this.planInterventionId = response.intervention.id;
                
                let mapIntervention = {...response.intervention}
                mapIntervention.adresse = (mapIntervention.adresse?.code_postal || '-') + " " + (mapIntervention.adresse?.ville || '-');
                mapIntervention.client_adresse = response.intervention.adresse;
                this.planIntervention = mapIntervention;
            }

            this.displayForm = false
            this.$forceUpdate()
            setTimeout(() => {
                this.displayForm = true
            }, 100)

            this.$eventHub.$emit('refresh-pastilles', 'interventions_a_planifier')
        },
    }
}
</script>

<style scoped>
html, body {
    background: #fff !important;
}
</style>